import { AUTH_INITIALIZER_MODULE } from './auth-initializer.provider';

export { AUTH_INITIALIZER_MODULE };

export default [AUTH_INITIALIZER_MODULE];
